module.exports = __webpack_public_path__ + "img/39_50.d2afcd25.png";